import {useScene, useServerTime} from '@glark-newco/game-library';
import {Group} from '@mantine/core';
import {useEffect, useState} from 'react';
import {CrunchTimeButton} from './CrunchTimeButton';
import {DealTilesButton} from './DealTilesButton';
import {EndGameButton} from './EndGameButton';
import {StartTimerButton} from './StartTimerButton';
import {useGameCompletion} from '../state/signlinesBoardSlice';
import {useCrunchTimeStartTime, useIsGameStarted} from '../state/signlinesTimestampsSlice';

export function FacilitatorActions() {
    const scene = useScene();
    const crunchTimeStartTime = useCrunchTimeStartTime();
    const isGameStarted  = useIsGameStarted();
    const {isComplete} = useGameCompletion();
    const [isGameTimeExpired, setGameTimeExpired] = useState(false);
    const serverTime = useServerTime();

    useEffect(() => {
        if (!crunchTimeStartTime) return;
        const delaySeconds = crunchTimeStartTime.add(20, 'seconds').unix() - serverTime.unix();
        const timeoutId = setTimeout(() => {
            // Ensure this component gets re-rendered at the relevant point in time.
            setGameTimeExpired(true);
        }, delaySeconds > 0 ? delaySeconds * 1000 : 0);
        return () => clearTimeout(timeoutId);
    }, [crunchTimeStartTime]);

    // Not using useGameOver here as that depends on ServerTime and our overlay isn't inside a <ServerTimeProvider/>
    const gameOver = !!crunchTimeStartTime && (isComplete || isGameTimeExpired);

    return (<>
        <Group
            data-testid="facilitator-actions"
            style={{
                width: '20%',
                position: 'absolute',
                pointerEvents: 'initial',
                right: '1rem',
                top: '2.5rem',
            }}>
            { scene === 'LOBBY' &&
                <DealTilesButton/>
            }
            { scene === 'PLAY' && !isGameStarted &&
                <StartTimerButton/>
            }
            { scene === 'PLAY' && isGameStarted &&
                <CrunchTimeButton/>
            }
            { scene === 'PLAY' && gameOver &&
                <EndGameButton/>
            }
        </Group>
    </>);
}
